/* Hair Up Brownie landing (page.hair-up-brownie): carrossel UGC, countdown, pop-up, formulário (Klaviyo) e FAQ.
   Carregado uma vez em layout/theme.liquid (só no template hair-up-brownie); o guard evita correr duas vezes. */
(function () {
  if (window.HUB_LANDING) return;

  var EMAIL_RE = /^\S+@\S+\.\S+$/;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function each(root, selector, fn) {
    Array.prototype.forEach.call(root.querySelectorAll(selector), fn);
  }

  function once(el, key) {
    if (el.dataset[key]) return false;
    el.dataset[key] = '1';
    return true;
  }

  // Altura do header do tema quando é sticky/fixo, para o scroll não esconder o topo do formulário
  function stickyOffset() {
    var offset = 0;
    each(document, '#shopify-section-header, .shopify-section-group-header-group, .header-container, .site-header', function (el) {
      var pos = window.getComputedStyle(el).position;
      if (pos !== 'fixed' && pos !== 'sticky') return;
      var r = el.getBoundingClientRect();
      if (r.top <= 1 && r.bottom > offset) offset = r.bottom;
    });
    return offset;
  }

  /* Formulário */
  function initWaitlist(form) {
    if (!once(form, 'hubReady')) return;
    var copy = JSON.parse(form.querySelector('[data-hub-copy]').textContent);
    var block = form.querySelector('[data-hub-block]');
    var success = form.querySelector('[data-hub-success]');
    var nameInput = form.querySelector('[data-hub-name]');
    var input = form.querySelector('[data-hub-email]');
    var error = form.querySelector('[data-hub-error]');
    var submit = form.querySelector('[data-hub-submit]');
    var intentCopy = form.querySelector('[data-hub-intent-copy]');
    var seg = form.querySelector('.hub-seg');
    var intent = form.dataset.defaultIntent === 'online' ? 'online' : 'popup';

    function setIntent(next) {
      intent = next === 'online' ? 'online' : 'popup';
      each(form, '[data-hub-intent]', function (btn) {
        btn.setAttribute('aria-checked', btn.dataset.hubIntent === intent ? 'true' : 'false');
        btn.tabIndex = btn.dataset.hubIntent === intent ? 0 : -1;
      });
      intentCopy.textContent = copy[intent].copy;
      submit.textContent = copy[intent].submit;
    }

    // Balão vermelho por cima do campo em falta
    function tip(field, msg) {
      var el = field.parentNode.querySelector('[data-hub-tip]');
      el.textContent = msg || '';
      el.hidden = !msg;
      field.setAttribute('aria-invalid', msg ? 'true' : 'false');
    }
    function clearErrors() {
      tip(nameInput, '');
      tip(input, '');
      error.textContent = '';
      error.hidden = true;
    }

    // Destaque da opção não selecionada quando o formulário entra no ecrã (como no protótipo)
    var peekTimers = [];
    function peek(delay) {
      peekTimers.forEach(clearTimeout);
      peekTimers = [[0, true], [400, false], [750, true], [1150, false], [1500, true], [1900, false]].map(function (step) {
        return setTimeout(function () { seg.classList.toggle('is-peek', step[1]); }, delay + step[0]);
      });
    }
    form.hubPeek = peek;
    if ('IntersectionObserver' in window) {
      // Visível = topo acima de 55% do ecrã e fundo abaixo de 20%
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !form.hubCtaScrolling && !block.hidden) peek(300);
        });
      }, { rootMargin: '-20% 0px -45% 0px' }).observe(block);
    }

    each(form, '[data-hub-intent]', function (btn) {
      btn.addEventListener('click', function () { setIntent(btn.dataset.hubIntent); });
      btn.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        e.preventDefault();
        setIntent(intent === 'popup' ? 'online' : 'popup');
        form.querySelector('[data-hub-intent="' + intent + '"]').focus();
      });
    });

    [nameInput, input].forEach(function (el) {
      el.addEventListener('input', function () { tip(el, ''); });
      // Liga já o captcha do cliente Shopify, para estar pronto quando a pessoa submeter
      el.addEventListener('focus', function () { bindShopifyCaptcha(form); }, { once: true });
    });

    block.addEventListener('submit', function (e) {
      e.preventDefault();
      var name = nameInput.value.trim();
      var email = input.value.trim();
      clearErrors();
      if (!name) {
        tip(nameInput, copy.errorName);
        nameInput.focus();
        return;
      }
      if (!email || !EMAIL_RE.test(email)) {
        tip(input, email ? copy.errorEmail : copy.errorEmailEmpty);
        input.focus();
        return;
      }
      submit.disabled = true;
      submit.setAttribute('aria-busy', 'true');

      // Klaviyo decide o sucesso; o cliente no Shopify é um extra, corre à parte e não bloqueia a inscrição
      subscribe(form.dataset, name, email, intent).then(function () {
        try { shopifyCustomer(form, form.dataset, name, email, intent); } catch (e) { console.warn('[Hair Up Brownie] Shopify:', e); }
        success.querySelector('[data-hub-success-copy]').textContent = copy[intent].success.replace('{email}', email);
        block.hidden = true;
        success.hidden = false;
        success.querySelector('[data-hub-success-title]').focus();
      }).catch(function (err) {
        console.error('[Hair Up Brownie] Klaviyo:', err);
        error.textContent = copy.errorNetwork;
        error.hidden = false;
      }).then(function () {
        submit.disabled = false;
        submit.removeAttribute('aria-busy');
      });
    });

    form.hubSetIntent = setIntent;
    setIntent(intent);
  }

  // Klaviyo Client Subscriptions API: uma lista por opção (single opt-in), idioma da página no perfil
  function subscribe(cfg, name, email, intent) {
    var key = (cfg.klaviyoKey || '').trim();
    var list = ((intent === 'online' ? cfg.klaviyoListOnline : cfg.klaviyoListPopup) || '').trim();
    var properties = {
      idioma: cfg.lang || 'pt',
      hair_up_brownie_intent: intent,
      source: cfg.source || 'LP Hair Up Brownie'
    };
    if (!key || !list) {
      console.warn('[Hair Up Brownie] Klaviyo sem public key ou sem o list ID desta opção nas settings da secção: modo de teste, nada foi enviado.', { first_name: name, email: email, properties: properties });
      return Promise.resolve();
    }
    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: properties.source,
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                first_name: name,
                properties: properties,
                subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
              }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: list } } }
      }
    };
    return fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(key), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/vnd.api+json',
        'Accept': 'application/vnd.api+json',
        'revision': cfg.klaviyoRevision || '2026-07-15'
      },
      body: JSON.stringify(payload)
    }).then(function (res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
    });
  }

  // Cliente no Shopify pelo formulário de newsletter nativo (form_type=customer), com tags para segmentar.
  // O captcha da Shopify (captcha-bootstrap) cancela o envio de forms de cliente que ainda não estejam ligados
  // ao hCaptcha, e só os liga quando recebem focusin/change. O form escondido nunca recebe foco, por isso
  // ligamo-lo quando a pessoa usa o formulário visível (evita carregar o hCaptcha em todas as visitas) e,
  // no envio, esperamos pelo data-hcaptcha-bound antes de submeter para o iframe escondido.
  function shopifyForm(root) { return root.querySelector('form[id^="hub-shopify-form-"]'); }

  function bindShopifyCaptcha(root) {
    var sf = shopifyForm(root);
    if (!sf || sf.hasAttribute('data-hcaptcha-bound') || sf.dataset.hubBinding) return;
    sf.dataset.hubBinding = '1';
    sf.dispatchEvent(new FocusEvent('focusin', { bubbles: true }));
  }

  function whenBound(sf, timeout) {
    return new Promise(function (resolve) {
      var start = Date.now();
      (function check() {
        if (sf.hasAttribute('data-hcaptcha-bound')) return resolve(true);
        if (Date.now() - start > timeout) return resolve(false);
        setTimeout(check, 150);
      })();
    });
  }

  function shopifyCustomer(root, cfg, name, email, intent) {
    var ready = (cfg.klaviyoKey || '').trim() && ((intent === 'online' ? cfg.klaviyoListOnline : cfg.klaviyoListPopup) || '').trim();
    var sf = shopifyForm(root);
    var sink = root.querySelector('iframe[name^="hub-shopify-sink-"]');
    if (!ready || !sf || !sink) return;
    var lang = /^(pt|es|en|de|nl)$/.test(cfg.lang) ? cfg.lang : 'pt';
    sf.querySelector('[data-hub-shopify-email]').value = email;
    sf.querySelector('[data-hub-shopify-name]').value = name;
    sf.querySelector('[data-hub-shopify-tags]').value = ['lang_' + lang, 'lp-hair-up-brownie-' + intent].join(', ');
    sf.target = sink.name;
    sink.addEventListener('load', function onLoad() {
      sink.removeEventListener('load', onLoad);
      var url = '';
      try { url = sink.contentWindow.location.href; } catch (e) {}
      if (/customer_posted=true/.test(url)) console.info('[Hair Up Brownie] Cliente Shopify criado/atualizado.');
      else console.warn('[Hair Up Brownie] Shopify não confirmou o cliente (Klaviyo OK). Resposta:', url);
    });
    bindShopifyCaptcha(root);
    whenBound(sf, 10000).then(function (bound) {
      if (!bound) {
        console.warn('[Hair Up Brownie] O captcha da Shopify não ficou pronto: cliente não criado no Shopify (Klaviyo OK).');
        return;
      }
      // requestSubmit dispara o submit que o hCaptcha interceta (verificação invisível) antes de enviar para o iframe
      if (sf.requestSubmit) sf.requestSubmit(); else sf.submit();
    });
  }

  // CTAs: data-hub-goto="popup" | "online" | "current"
  document.addEventListener('click', function (e) {
    var cta = e.target.closest && e.target.closest('[data-hub-goto]');
    if (!cta) return;
    var target = document.getElementById('inscricao');
    if (!target) return;
    e.preventDefault();
    var form = target.closest('[data-hub-waitlist]') || target;
    var intent = cta.dataset.hubGoto;
    if ((intent === 'popup' || intent === 'online') && form.hubSetIntent) form.hubSetIntent(intent);
    var top = target.getBoundingClientRect().top + window.pageYOffset - stickyOffset();
    window.scrollTo({ top: Math.max(0, top), behavior: reduceMotion ? 'auto' : 'smooth' });
    // Durante o scroll do CTA não pisca; no fim do scroll pisca logo
    form.hubCtaScrolling = true;
    clearTimeout(form.hubCtaTimer);
    form.hubCtaTimer = setTimeout(function () {
      form.hubCtaScrolling = false;
      if (form.hubPeek) form.hubPeek(0);
    }, 800);
  });

  /* Carrossel UGC */
  function initCarousel(root) {
    if (!once(root, 'hubReady')) return;
    var track = root.querySelector('[data-hub-track]');
    var thumb = root.querySelector('[data-hub-thumb]');
    if (!track) return;

    function update() {
      var vis = track.scrollWidth ? track.clientWidth / track.scrollWidth : 1;
      var max = track.scrollWidth - track.clientWidth;
      var p = max > 0 ? track.scrollLeft / max : 0;
      if (thumb) {
        thumb.style.width = (Math.min(1, vis) * 100) + '%';
        thumb.style.transform = 'translateX(' + (p * (1 - vis) / Math.max(vis, 0.0001) * 100) + '%)';
      }
    }

    each(root, '[data-hub-dir]', function (btn) {
      btn.addEventListener('click', function () {
        var dir = btn.dataset.hubDir === 'prev' ? -1 : 1;
        track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: reduceMotion ? 'auto' : 'smooth' });
      });
    });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();

    // Vídeos UGC: nada é descarregado antes de a pessoa tocar no play. Não pré-carregar ao aproximar do
    // ecrã: o HLS nativo ignora preload="metadata" e descarrega segmentos (testado: ~20 MB por 2 vídeos).
    // HLS onde o browser o suporta (arranca em 480p e adapta), MP4 no resto; carrega logo no pointerdown.
    var canHls = (function () {
      var v = document.createElement('video');
      return !!(v.canPlayType && v.canPlayType('application/vnd.apple.mpegurl'));
    })();

    function prepare(card, level) {
      var tpl = card.querySelector('template');
      var video = card.querySelector('video');
      if (!video && tpl) {
        card.appendChild(tpl.content.cloneNode(true));
        video = card.querySelector('video');
      }
      if (!video) return null;
      if (!video.getAttribute('src')) {
        var src = (canHls && video.dataset.hls) || video.dataset.mp4 || video.dataset.hls;
        if (!src) return null;
        video.preload = level;
        video.src = src;
      } else if (level === 'auto' && video.preload !== 'auto') {
        video.preload = 'auto';
      }
      return video;
    }

    var cards = root.querySelectorAll('[data-hub-card]');

    Array.prototype.forEach.call(cards, function (card) {
      var trigger = card.querySelector('[data-hub-play]');
      if (!trigger || !card.querySelector('template')) return;
      // O toque começa antes do clique: aproveita para começar a carregar
      trigger.addEventListener('pointerdown', function () { prepare(card, 'auto'); }, { passive: true });
      trigger.addEventListener('click', function () {
        each(root, '[data-hub-card] video', function (v) { v.pause(); });
        var video = prepare(card, 'auto');
        if (!video) return;
        card.classList.add('is-playing');
        // Com som: o play parte de um clique, por isso os browsers permitem áudio.
        // Se algum recusar (política de autoplay), arranca sem som em vez de não arrancar.
        video.muted = false;
        var played = video.play();
        if (played && played.catch) played.catch(function () {
          video.muted = true;
          video.play().catch(function () {});
        });
      });
    });
  }

  /* Countdown */
  function initCountdown(el) {
    if (!once(el, 'hubReady')) return;
    var target = Date.parse(el.dataset.target);
    if (isNaN(target)) return;
    var parts = {
      d: el.querySelector('[data-unit="d"]'),
      h: el.querySelector('[data-unit="h"]'),
      m: el.querySelector('[data-unit="m"]'),
      s: el.querySelector('[data-unit="s"]')
    };
    function pad(n) { return String(n).padStart(2, '0'); }
    function tick() {
      var diff = Math.max(0, target - Date.now());
      parts.d.textContent = pad(Math.floor(diff / 864e5));
      parts.h.textContent = pad(Math.floor(diff / 36e5) % 24);
      parts.m.textContent = pad(Math.floor(diff / 6e4) % 60);
      parts.s.textContent = pad(Math.floor(diff / 1e3) % 60);
      if (!diff) clearInterval(timer);
    }
    var timer = setInterval(tick, 1000);
    tick();
  }

  /* FAQ: um aberto de cada vez */
  function initFaq(root) {
    if (!once(root, 'hubReady')) return;
    var items = root.querySelectorAll('[data-hub-faq-item]');
    function set(item, open) {
      item.classList.toggle('is-open', open);
      item.querySelector('[data-hub-faq-q]').setAttribute('aria-expanded', open ? 'true' : 'false');
      item.querySelector('[data-hub-faq-a]').hidden = !open;
    }
    Array.prototype.forEach.call(items, function (item) {
      item.querySelector('[data-hub-faq-q]').addEventListener('click', function () {
        var open = !item.classList.contains('is-open');
        Array.prototype.forEach.call(items, function (other) { set(other, false); });
        set(item, open);
      });
    });
  }

  function init(root) {
    root = root || document;
    each(root, '[data-hub-waitlist]', initWaitlist);
    each(root, '[data-hub-carousel]', initCarousel);
    each(root, '[data-hub-countdown]', initCountdown);
    each(root, '[data-hub-faq]', initFaq);
  }

  window.HUB_LANDING = { init: init };
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
})();
